import React, { useEffect, useRef, useState } from "react";
import Pelota from "../../assets/img/futbol.svg";
import FiltrosIcon from "../../assets/img/filtros.svg";
import {
  NextArrow,
  NextArrowMobile,
  PreviousArrow,
  PreviousArrowMobile,
} from "../SliderArrows";
import Slider from "react-slick";
import useWindowWidth from "../../hooks/useWindowWidth";

const getSlidesToShow = (width) => {
  if (width < 325) return 2;
  if (width < 460) return 3;
  if (width < 768) return 4;
  if (width < 1024) return 3;
  if (width < 1200) return 6;
  return 7;
};

const Categoria = ({ nombre, pathFoto, isActive, onClick }) => {
  return (
    <button className={`btn cat ${isActive ? "active" : ""}`} onClick={onClick}>
      <div className="circle">
        <img src={pathFoto} alt={nombre} />
      </div>
      <span>{nombre}</span>
    </button>
  );
};

const Subcategoria = ({ nombre, onClick, isActive }) => {
  return (
    <button
      className={`subcat btn ${isActive ? "active" : ""}`}
      onClick={onClick}>
      <span>{nombre}</span>
    </button>
  );
};

const ListaSubcategoria = ({
  subcategorias,
  setSelectedSubCategoria,
  selectedSubCategoria,
}) => {
  return (
    <div className="filtros-subcats">
      {subcategorias ? (
        subcategorias.map((subcat, i) => (
          <Subcategoria
            nombre={subcat.nombre}
            key={i}
            pathFoto={Pelota}
            onClick={() => setSelectedSubCategoria(subcat.nombre)}
            isActive={selectedSubCategoria === subcat.nombre}
          />
        ))
      ) : (
        <p>No hay informacion para mostrar</p>
      )}
    </div>
  );
};

const FiltrosToggle = ({ visible, onClick }) => {
  return (
    <button type="button" className="filtros-toggle" onClick={onClick}>
      <img src={FiltrosIcon} alt="" />
      <span>{visible ? "Ocultar filtros" : "Mostrar filtros"}</span>
    </button>
  );
};

const EventosHeader = ({
  categorias,
  selectedCategoria,
  setSelectedCategoria,
  selectedSubCategoria,
  setSelectedSubCategoria,
}) => {
  const [slideIndex, setSlideIndex] = useState(0);
  const [slidesToShow, setSlidesToShow] = useState(0);
  const [updateCount, setUpdateCount] = useState(0);
  const [mostrarFiltros, setMostrarFiltros] = useState(true);
  let sliderRef = useRef(null);
  const windowWidth = useWindowWidth();

  useEffect(() => {
    setSlidesToShow(getSlidesToShow(windowWidth));
  }, [windowWidth]);

  useEffect(() => {
    setMostrarFiltros(true);
  }, [selectedCategoria]);

  const selectedCat = categorias.find((cat) => cat.nombre === selectedCategoria);

  const handleSwitch = (index, active, setter) => {
    if (index === active) {
      setter(null);
    } else {
      setter(index);
    }
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: Math.min(slidesToShow, categorias.length),
    slidesToScroll: Math.min(slidesToShow, categorias.length),
    initialSlide: 0,
    afterChange: () => setUpdateCount(updateCount + 1),
    beforeChange: (current, next) => setSlideIndex(next),
    prevArrow: (
      <PreviousArrow
        hidden={categorias.length <= slidesToShow}
        disabled={slideIndex === 0}
        onClick={() => {
          setSelectedCategoria(null);
          sliderRef.slickGoTo(0);
        }}
      />
    ),
    nextArrow: (
      <NextArrow
        hidden={categorias.length <= slidesToShow}
        disabled={categorias.length - slideIndex <= slidesToShow}
        onClick={() => {
          setSelectedCategoria(null);
          sliderRef.slickGoTo(slideIndex + slidesToShow - 1);
        }}
      />
    ),
  };

  return (
    <div className="categ-free general-container">
      <div className="slider-container">
        <Slider
          style={{ display: "flex", justifyContent: "center" }}
          ref={(slider) => {
            sliderRef = slider;
          }}
          {...settings}>
          {categorias.map((cat, index) => {
            return (
              <Categoria
                nombre={cat.nombre}
                pathFoto={cat.fotoIcono}
                onClick={() =>
                  handleSwitch(
                    cat.nombre,
                    selectedCategoria,
                    setSelectedCategoria
                  )
                }
                style={{ width: "0px" }}
                isActive={cat.nombre === selectedCategoria}
                key={index}
              />
            );
          })}
        </Slider>

        <div className="custom_arrows">
          <PreviousArrowMobile
            disabled={slideIndex === 0}
            onClick={() => {
              setSelectedCategoria(null);
              sliderRef.slickGoTo(0);
            }}
          />
          <NextArrowMobile
            disabled={categorias.length - slideIndex <= slidesToShow}
            onClick={() => {
              setSelectedCategoria(null);
              sliderRef.slickGoTo(slideIndex + slidesToShow - 1);
            }}
          />
        </div>
      </div>

      {selectedCat && (
        <div className="filtros-row">
          <FiltrosToggle
            visible={mostrarFiltros}
            onClick={() => setMostrarFiltros((v) => !v)}
          />
          <div className={`filtros-collapse ${mostrarFiltros ? "" : "is-hidden"}`}>
            <div className="filtros-collapse-inner">
              <ListaSubcategoria
                subcategorias={selectedCat.categorias}
                setSelectedSubCategoria={setSelectedSubCategoria}
                selectedSubCategoria={selectedSubCategoria}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default EventosHeader;
